const authMap = {
  userToken: 'userToken',
  userData: 'userData',
  userAvatar: 'userAvatar',
};

export default authMap;
